module.exports = __webpack_public_path__ + "img/appltCourse-img14.ea1d87eb.png";